export default {
    language: "Bahasa Melayu",
    StripeSuccess: {
        loading: "Memproses pembayaran anda...",
        successMessage: "Langganan berjaya diaktifkan!",
        processingError: "Pemprosesan pembayaran gagal, sila hubungi kami",
    },
    UserDetail: {
        userInfo: {
            emailLabel: "E-mel",
            createdAt: "Dicipta pada",
            noRecord: "Tiada rekod",
            loginTime: "Masa log masuk",
        },
        orders: {
            title: "Sejarah pesanan",
            loading: "Memuatkan...",
            refresh: "Muat semula",
            orderAmount: "Jumlah",
            points: "Mata",
            createdAt: "Dicipta pada",
            orderType: "Jenis",
            status: "Status",
            noOrders: "Tiada pesanan",
            goToSubscription: "Beli mata",
            freeCredit: "Kredit percuma",
            paidCredit: "Kredit berbayar",
            queryOrderFailed: "Gagal membuat pertanyaan pesanan",
            statusPaid: "Dibayar",
            statusPending: "Tertunda",
            statusCancelled: "Dibatalkan",
            statusDeactivated: "Dinyahaktifkan",
            checkoutUrlNotAvailable: "Gagal mendapatkan URL pembayaran",
            verifyingPayment: "Mengesahkan status pembayaran...",
            paymentSuccess: "Pembayaran berjaya",
            paymentPending: "Pesanan sedang menunggu pembayaran, sila lengkapkan pembayaran",
            paymentFailed: "Pembayaran gagal atau dibatalkan",
            paymentStatus: "Status pembayaran",
            paymentStatusDescription: "Adakah anda telah menyelesaikan pembayaran?",
            cancelPayment: "Batalkan pembayaran",
            completedPayment: "Pembayaran selesai",
            warning: "Amaran",
            confirmCancelOrder: "Adakah anda pasti ingin membatalkan pesanan ini? Tindakan ini tidak boleh diundur.",
            cancel: "Batal",
            confirm: "Sahkan",
            cancellingOrder: "Membatalkan pesanan...",
            orderCancelledSuccess: "Pesanan dibatalkan",
            cancelOrderFailed: "Gagal membatalkan pesanan",
            checkOrderStatusFailed: "Gagal memeriksa status pesanan",
            promptClick: "Klik status \"Tertunda\" untuk meneruskan pembayaran",
        }
    },
    UserFeedback: {
        title: "Maklum Balas Pengguna",
        feedback: "Dengar ulasan sebenar daripada pencipta dan profesional di seluruh dunia tentang teknologi pemprosesan imej AI kami.",
        people: [
            {
                id: 1,
                avatar: "feedback-user-avatar-1.jpg",
                name: "Encik Lin",
                profession: "Editor Video & Pencipta Kandungan",
                rating: 5,
                comment: "Hebat! ClixMagicAI sangat pantas! Muat naik video dengan tera air, dalam beberapa minit anda akan mendapat versi tanpa tera air, tiada pengurangan kualiti sama sekali. Alat yang mesti ada untuk menyingkirkan tera air!"
            },
            {
                id: 2,
                avatar: "feedback-user-avatar-2.jpg",
                name: "Puan Su",
                profession: "Pakar Pemasaran Media Sosial",
                rating: 5,
                comment: "ClixMagicAI telah menyelamatkan perpustakaan bahan Instagram saya! Ia dapat mengenal pasti tera air yang kompleks dengan tepat, pemprosesan pinggir lebih halus daripada perisian sebelumnya, dan hasil yang kelihatan lebih semula jadi."
            },
            {
                id: 3,
                avatar: "feedback-user-avatar-3.jpg",
                name: "Encik Chen",
                profession: "Penerbit Kandungan Video Pendek",
                rating: 5,
                comment: "Penyingkiran tera air dengan ClixMagicAI sangat mudah. Proses bahan TikTok semasa perjalanan ke pejabat, dan muat turun versi HD sejurus selepas tiba. Kecekapan meningkat dua kali ganda! Sangat berguna untuk profesional media."
            },
            {
                id: 4,
                avatar: "feedback-user-avatar-4.jpg",
                name: "Encik Huang",
                profession: "Pereka Grafik & Pengarah Kreatif Visual",
                rating: 5,
                comment: "Sebagai pereka, saya sangat berpuas hati! Semasa memproses imej sampel dengan logo pelanggan, tekstur latar belakang dipulihkan dengan semula jadi, tiada kesan Photoshop, dan menjimatkan banyak masa pasca-pemprosesan."
            },
            {
                id: 5,
                avatar: "feedback-user-avatar-5.jpg",
                name: "Puan Emily",
                profession: "Pencipta Kandungan Digital Bebas",
                rating: 5,
                comment: "Saya telah jumpa harta karun! Harga keahlian jauh lebih murah daripada produk penyingkiran tera air lain di pasaran, tetapi kesan penyingkiran tera air sebenarnya lebih baik, terutamanya ketika memproses tera air lutsinar bergradian."
            },
            {
                id: 6,
                avatar: "feedback-user-avatar-6.jpg",
                name: "Encik Robertson",
                profession: "Pembangun Kursus Latihan Korporat",
                rating: 5,
                comment: "ClixMagicAI sangat mudah kerana tidak perlu dipasang! Komputer syarikat saya mempunyai sekatan kebenaran pemasangan perisian, tetapi sekarang saya boleh memproses bahan kursus dengan pelayar sahaja, di mana-mana dan bila-bila masa."
            },
            {
                id: 7,
                avatar: "feedback-user-avatar-7.jpg",
                name: "Puan Zhou",
                profession: "Suri Rumah & Editor Grafik Komuniti",
                rating: 5,
                comment: "Antara muka operasi sangat mudah sehingga nenek saya pun boleh guna! Jika anda tiada masa untuk belajar perisian profesional seperti Photoshop, anda mesti cuba ClixMagicAI. Sangat sesuai untuk pengguna kurang mahir seperti saya. Haha~"
            },
            {
                id: 8,
                avatar: "feedback-user-avatar-8.jpg",
                name: "Encik Johnson",
                profession: "Perancang Visual E-dagang",
                rating: 5,
                comment: "ClixMagicAI sangat hebat, boleh menyingkirkan imej, video, objek kecil, orang, teks dan sebagainya. Fungsi lengkap, saya cadangkan untuk semua orang~"
            },
            {
                id: 9,
                avatar: "feedback-user-avatar-9.jpg",
                name: "Puan Fang",
                profession: "Penggemar Fotografi & Berkongsi Kandungan Dalam Talian",
                rating: 5,
                comment: "Wah~ Akhirnya saya jumpa alat penyingkiran tera air yang tidak merosakkan kualiti imej! Ajaib seperti sihir~ Mengedit gambar tidak lagi menjadi masalah! Amat disyorkan!!!"
            },
            {
                id: 10,
                avatar: "feedback-user-avatar-10.jpg",
                name: "Encik Williams",
                profession: "Pengajar Pendidikan Dalam Talian",
                rating: 5,
                comment: "Fungsi ingatan kedudukan tera air sangat berguna! Semasa memproses siri video kursus, saya tidak perlu memilih berulang kali, menjimatkan sekurang-kurangnya setengah jam kerja, dan meningkatkan kecekapan persediaan pengajaran saya dengan ketara."
            }
        ]
    },
    Order: {
        purchasePoints: "Beli Mata",
        subtitle: "Pilih pakej mata yang sesuai untuk menikmati perkhidmatan penyingkiran tera air berkualiti tinggi",
        loginReminderDesc: "Log masuk untuk memilih dan membeli mata",
        freeTag: "Percuma",
        freePlan: "Pelan Percuma",
        autoActivated: "Diaktifkan secara automatik selepas log masuk",
        points: "Mata",
        autoIncluded: "Hadiah percuma",
        discount: "Diskaun",
        purchase: "Beli Sekarang",
        paymentStatusDescription: "Adakah anda telah melengkapkan pembayaran?",
        paymentNotCompleted: "Pembayaran belum selesai",
        queryOrderFailed: "Gagal memeriksa status pesanan",
        cancelPayment: "Batalkan Pembayaran",
        completedPayment: "Pembayaran Selesai",
        warning: "Amaran",
        confirmCancelOrder: "Adakah anda pasti mahu membatalkan pesanan ini? Tindakan ini tidak boleh diundur.",
        cancel: "Batal",
        confirm: "Sahkan",
        selectProductFirst: "Sila pilih pakej terlebih dahulu",
        creatingOrder: "Mencipta pesanan...",
        orderCreated: "Pesanan berjaya dicipta",
        createOrderFailed: "Gagal mencipta pesanan",
        checkoutUrlNotAvailable: "Gagal mendapatkan pautan pembayaran",
        cancellingOrder: "Membatalkan pesanan...",
        orderCancelledSuccess: "Pesanan telah dibatalkan",
        cancelOrderFailed: "Gagal membatalkan pesanan",
        verifyingPayment: "Memeriksa status pembayaran...",
        paymentSuccess: "Pembayaran berjaya",
        paymentPending: "Pesanan menunggu pembayaran, sila lengkapkan pembayaran",
        paymentFailed: "Pembayaran gagal atau dibatalkan",
        checkOrderStatusFailed: "Gagal memeriksa status pesanan",
        quickStart: "Mula Pantas",
        shortTerm: "Penggunaan Jangka Pendek",
        recommended: "Disyorkan",
        bestValue: "Nilai Terbaik",
    },
    Login: {
        title: "Log Masuk",
        subtitle: "Log masuk pantas dengan akaun media sosial",
        memberTip: "Log masuk untuk menikmati lebih banyak ciri",
        types: [
            {
                id: 1,
                provider: "github",
                icon: "fab fa-github",
                desc: "Log masuk dengan GitHub"
            },
            {
                id: 2,
                provider: "google",
                icon: "fab fa-google",
                desc: "Log masuk dengan Google"
            }
        ],
        error: {
            serverError: "Ralat pelayan, sila cuba lagi kemudian",
            networkError: "Ralat rangkaian, sila periksa sambungan anda"
        }
    },
    OAuthCallback: {
        loading: "Memproses permintaan log masuk",
        pleaseWait: "Sila tunggu, mengesahkan maklumat log masuk...",
        error: "Log masuk gagal",
        backToHome: "Kembali ke Laman Utama",
        success: "Log masuk berjaya",
        redirecting: "Mengalihkan ke laman utama..."
    },
    Nav:{
        title: "ClixMagicAI",
        logo: "logo.png",
        menu: {
            pricing: "Harga",
            faq: "Soalan Lazim",
        },
        login: "Log Masuk",
        userMenu: {
            account: "Akaun",
            logout: "Log Keluar",
            credit: "Mata",
            freeCredit: "Percuma",
            paidCredit: "Dibeli",
            nextUpdate: "Kemas kini mata seterusnya",
            language: "Bahasa",
            theme: "Tema",
        },
        userMenuIcons: {
            account: "fas fa-user-circle",
            logout: "fas fa-sign-out-alt",
            credit: "fas fa-credit-card",
            language: "fas fa-globe",
            theme: "fas fa-moon",
        },
    },
    ProductAdv: {
        title: "Ciri-ciri ClixMagicAI",
        advs: [
            {
                title: "Enjin Pengecaman AI: Mengesan Elemen Mengganggu Secara Automatik",
                desc: "Berdasarkan algoritma pembelajaran mendalam, ia secara automatik mengenal pasti tera air, teks, wajah dan elemen latar belakang kompleks dalam imej/video tanpa memerlukan penandaan manual. Menyokong format Instagram, TikTok dan platform lain, dengan perlindungan data peribadi yang ketat.",
                beforeImage: "adv-before-1.jpg",
                afterImage: "adv-after-1.jpg",
                click: "Singkir Tera Air"
            },
            {
                title: "Pakar Pembersihan Imej: Buang Logo/Cap Tarikh dengan Cepat, Kualiti Terpelihara",
                desc: "Menyingkirkan dengan tepat tera air jenama, tarikh penggambaran, pelekat dan elemen mengganggu lain. AI secara automatik memulihkan tekstur latar belakang, imej selepas pemprosesan kelihatan semula jadi seperti yang asal, sempurna untuk siaran media sosial.",
                beforeImage: "adv-before-2.jpg",
                afterImage: "adv-after-2.jpg",
                click: "Singkir Tera Air"
            },
            {
                title: "Penyingkir Tera Air Dinamik: Padam Sari Kata Bergulir/Logo Platform",
                desc: "Singkirkan kad outro YouTube, tera air dinamik TikTok dan teks bergulir dengan satu klik. AI pintar menjejak dan memproses setiap bingkai, menghasilkan video 4K berkualiti tinggi yang lancar, menyokong format MP4/MOV dan lain-lain format popular.",
                beforeImage: "adv-before-3.jpg",
                afterImage: "adv-after-3.jpg",
                click: "Singkir Tera Air"
            }
        ]
    },
    Description:{
        title: "ClixMagicAI",
        desc: "Alat profesional berkuasa AI untuk menyingkirkan tera air dari imej, video dan PDF dengan cepat dan mudah, memberikan hasil yang semula jadi.",
        fileTypes: {
            image: 'Singkir Tera Air Imej',
            pdf: 'Singkir Tera Air PDF',
            video: 'Singkir Tera Air Video'
        },
        marketingTags: [
            { id: "freeTrialTag", text: "Percubaan Percuma Harian", icon: "fa-gift" },
            { id: "imageTag", text: "Penyingkiran Tera Air Imej", icon: "fa-image" },
            { id: "videoTag", text: "Penyingkiran Tera Air Video", icon: "fa-video" },
            { id: "aiPoweredTag", text: "Dikuasakan oleh AI", icon: "fa-robot" },
            { id: "noRegTag", text: "Log Masuk & Guna", icon: "fa-user-check" },
        ],
        videoPromt: "Akan Datang!",
        videoDesc: "Kami sedang membangunkan ciri penyingkiran tera air video yang akan memberikan pengalaman yang lebih baik."
    },
    Footer: {
        social: {
            title: "Hubungi Kami",
            logo: "logo.png",
            methods:[
                {
                    icon: "x-platform-icon",
                    link: "https://x.com/ClixMagicAI"
                },
                {
                    icon: "far fa-envelope",
                    link: "mailto:support@clixmagic.com",
                    text: "support@clixmagic.com"
                },
            ]
        },
        termsTitle: "Terma Undang-undang",
        terms: [
            {
                id: 1,
                title: "Dasar Privasi",
                link: "/privacy"
            },
            {
                id: 2,
                title: "Terma Perkhidmatan",
                link: "/terms"
            },
            {
                id: 3,
                title: "Dasar Kuki",
                link: "/cookie"
            }
        ],
        copyright: "© 2025 ClixMagicAI Hak Cipta Terpelihara."
    },
    Task: {
        image: {
            imageSupportText: 'Menyokong format jpg, jpeg, png, webp, heic, heif, maksimum 10MB setiap fail',
            imageFileTooLarge: 'Saiz fail melebihi had (maksimum 10MB)',
            invalidImageType: 'Format imej tidak disokong, sila muat naik JPG, JPEG, PNG, WEBP, HEIC atau HEIF',
            imageWillCost: 'Akan menggunakan: 1 mata',
            hiecSupportText: 'Format HEIC/HEIF akan ditukar kepada PNG secara automatik semasa penghantaran',
            hiecSuccess: 'Format HEIC/HEIF berjaya ditukar',
            hiecFailed: 'Penukaran format HEIC/HEIF gagal',
            processingImageTip: 'Memproses imej anda, sila tunggu...',
            guide: {
                title: 'Panduan Penggunaan',
                step1: 'Muat naik imej',
                step2: 'Sapu pada kawasan tera air atau biarkan model mengesan tera air secara automatik',
                step3: 'Klik hantar'
            }
        },
        common: {
            remaining: 'Baki mata',
            nextUpdate: 'Kemas kini mata seterusnya',
            handleError: 'Ralat semasa memproses fail, sila cuba fail lain',
            uploadFailed: 'Muat naik fail gagal',
            dragText: 'Seret fail ke sini atau',
            clickText: 'klik untuk muat naik',
            loginRequired: 'Sila log masuk untuk muat naik fail',
            noRemainingTasks: 'Semua mata anda telah habis',
            loginNow: 'Log Masuk Sekarang',
            upgradeNow: 'Beli Mata Sekarang',
            taskSubmitSuccess: 'Tugas berjaya dihantar',
            taskSubmitError: 'Penghantaran tugas gagal',
            taskRetrySuccess: 'Percubaan semula tugas berjaya dihantar!',
            taskRetryError: 'Percubaan semula tugas gagal dihantar!',
            processing: 'Memproses',
            submit: 'Hantar',
            waiting: 'Menunggu',
            completed: 'Selesai',
            failed: 'Gagal',
            cancelled: 'Dibatalkan',
            url_not_found: 'Gagal mendapatkan pautan',
            deleted: 'Dipadam',
            refreshSuccess: 'Senarai tugas telah dimuat semula',
            refreshFailed: 'Gagal memuat semula senarai tugas',
            deleteSuccess: 'Tugas berjaya dipadamkan',
            deleteFailed: 'Gagal memadam tugas',
            waitingForCompletion: 'Sila tunggu tugas semasa selesai sebelum mencuba lagi',
            loadOriginalImageFailed: 'Gagal memuat imej asal, sila cuba lagi',
            downloadFailed: 'Muat turun gagal',
            startingDownload: 'Memulakan muat turun...',
            noTasks: 'Tiada tugas',
            refresh: 'Muat Semula',
            sort: 'Susun',
            noFilterTasks: 'Tiada tugas {filter}',
            compare: 'Lihat perbandingan',
            originalImage: 'Imej asal',
            processedImage: 'Imej diproses',
            dragToCompare: '👈 Seret kiri-kanan untuk membandingkan 👉',
            cancel: "Batal",
            delete: "Padam",
            retry: "Cuba lagi",
            download: "Muat turun",
            createAt: "Dicipta pada",
            expiredAt: "Tamat tempoh pada",
        },
        video: {
            videoSupportText: 'Menyokong format mp4, mov, avi, mkv, maksimum 100MB setiap fail',
            videoFileTooLarge: 'Saiz fail melebihi had (maksimum 100MB)',
            invalidVideoType: 'Format video tidak disokong, sila muat naik MP4, MOV, AVI atau MKV',
            videoWillCost: 'Akan menggunakan: 3 mata',
            processingVideoTip: 'Memproses video anda, sila tunggu...',
            guide: {
                step1: 'Muat naik video',
                step2: 'Pilih jenis tera air dan tentukan kawasan tera air',
                step3: 'Klik hantar'
            },
            annotationTools: 'Alat Anotasi Tera Air',
            selectType: 'Pilih Jenis Tera Air',
            deleteAnnotation: 'Padam Anotasi',
            clearAllAnnotations: 'Padam Semua Anotasi',
            annotationHelp: 'Bantuan Anotasi',
            dragTip: 'Seret untuk melukis kawasan tera air',
            resizeTip: 'Laraskan saiz untuk padankan tera air',
            moveTip: 'Anotasi yang dibuat boleh dipindahkan',
            processing: 'Memproses',
            submit: 'Hantar',
            taskSubmitSuccess: 'Tugas berjaya dihantar',
            taskSubmitError: 'Penghantaran tugas gagal',
            retryTaskTip: 'Percubaan semula tugas berjaya dihantar',
            retryFailed: 'Percubaan semula tugas gagal',
            uploadFailed: 'Muat naik gagal',
            staticWatermarkDesc: 'Sesuai untuk tera air statik dengan kedudukan tetap',
            normalWatermarkDesc: 'Sesuai untuk tera air tetap biasa',
            dynamicWatermarkDesc: 'Sesuai untuk tera air dinamik yang berubah',
            moveWatermarkDesc: 'Sesuai untuk tera air yang perlu dipindahkan'
        },
    },
    Router: {
        home: "Laman Utama",
        terms: "Terma Perkhidmatan",
        privacy: "Dasar Privasi",
        cookie: "Dasar Kuki",
        user: "Pusat Pengguna",
    },
    Terms: {
        "tabs": {
            "terms": "Terma Perkhidmatan",
            "privacy": "Dasar Privasi",
            "cookies": "Dasar Kuki"
        },
        "lastUpdated": "Kemas kini terakhir: 20 Mei 2025",
        "terms": {
            "sections": [
                {
                    "title": "1. Pengenalan",
                    "description": "Selamat datang ke ClixMagicAI. Penggunaan perkhidmatan kami bermakna anda menerima terma perkhidmatan ini. Sila baca dengan teliti."
                },
                {
                    "title": "2. Penerangan Perkhidmatan",
                    "description": "ClixMagicAI menyediakan alat berasaskan AI untuk menghilangkan tera air dari imej, video dan fail PDF. Perkhidmatan kami bertujuan untuk kegunaan sah berikut:",
                    "items": [
                        "Menghilangkan tera air dari kandungan anda sendiri",
                        "Menghilangkan tera air dari kandungan yang anda mempunyai hak pengubahsuaian yang sesuai",
                        "Untuk tujuan pendidikan dan penyelidikan"
                    ]
                },
                {
                    "title": "3. Tanggungjawab Pengguna",
                    "description": "Dengan menggunakan ClixMagicAI, anda bersetuju untuk:",
                    "items": [
                        "Hanya memuat naik kandungan yang anda miliki atau mempunyai hak pengubahsuaian yang sesuai",
                        "Tidak menggunakan perkhidmatan kami untuk tujuan haram atau melanggar undang-undang",
                        "Tidak cuba mengelakkan langkah keselamatan atau sekatan penggunaan kami",
                        "Tidak menggunakan perkhidmatan kami untuk melanggar hak harta intelek pihak lain"
                    ]
                },
                {
                    "title": "4. Syarat Akaun",
                    "description": "Anda mungkin perlu membuat akaun untuk menggunakan beberapa ciri perkhidmatan kami. Untuk log masuk, anda boleh memilih untuk menggunakan akaun Google atau GitHub. Anda bertanggungjawab untuk:",
                    "items": [
                        "Mengekalkan keselamatan akaun anda",
                        "Semua aktiviti yang berlaku di bawah akaun anda",
                        "Memberikan maklumat akaun yang tepat (termasuk tetapi tidak terhad kepada avatar, e-mel, nama pengguna dan ID pengguna)"
                    ]
                },
                {
                    "title": "5. Perkhidmatan Percuma dan Berbayar",
                    "description": "ClixMagicAI menawarkan kuota asas percuma dan pilihan pembelian mata yang fleksibel untuk mengakses ciri penghilangan tera air kami:",
                    "items": [
                        "Kuota asas: Setiap pengguna akan secara automatik menerima 3 mata percuma setiap hari, yang boleh digunakan untuk pemprosesan kandungan",
                        "Peraturan penggunaan mata: Penghilangan tera air imej menggunakan 1 mata setiap operasi, penghilangan tera air video menggunakan 3 mata setiap operasi",
                        "Pembelian mata: Anda boleh memilih untuk membeli pakej mata untuk penggunaan lebih banyak, semua mata yang dibeli sah secara kekal, tanpa sekatan tamat tempoh",
                        "Dasar bayaran balik: Disebabkan sifat serta-merta dan maya perkhidmatan digital, mata tidak boleh dibayar balik setelah berjaya dibeli"
                    ]
                },
                {
                    "title": "6. Hak Harta Intelek",
                    "description": "Perkhidmatan ClixMagicAI, termasuk semua perisian, reka bentuk dan kandungan yang kami buat, adalah harta intelek kami. Anda tidak boleh menyalin, mengubah suai atau membuat karya terbitan berdasarkan perkhidmatan kami tanpa kebenaran."
                },
                {
                    "title": "7. Had Liabiliti",
                    "description": "ClixMagicAI menyediakan perkhidmatan \"sebagaimana adanya\", tanpa jaminan jenis apa pun. Kami tidak bertanggungjawab atas sebarang kerosakan yang timbul daripada penggunaan perkhidmatan kami."
                },
                {
                    "title": "8. Perubahan pada Terma",
                    "description": "Kami boleh mengubah terma ini pada bila-bila masa. Penggunaan ClixMagicAI yang berterusan selepas perubahan terma bermakna anda menerima terma yang diubah."
                },
                {
                    "title": "9. Penamatan",
                    "description": "Kami berhak untuk menamatkan atau menggantung akses anda kepada perkhidmatan kami dengan serta-merta, tanpa notis terlebih dahulu, jika kami percaya tingkah laku anda melanggar terma ini atau membahayakan pengguna lain, diri kami sendiri atau pihak ketiga."
                },
                {
                    "title": "10. Undang-undang yang Terpakai",
                    "description": "Terma ini akan dikawal oleh undang-undang yang terpakai di tempat pendaftaran syarikat kami, tanpa mengira peruntukan konflik undang-undang."
                }
            ]
        },
        "privacy": {
            "sections": [
                {
                    "title": "1. Pengenalan",
                    "description": "Di ClixMagicAI, kami menghargai privasi anda dan komited untuk melindungi data peribadi anda. Dasar Privasi ini menerangkan bagaimana kami mengumpul, menggunakan dan melindungi maklumat anda semasa anda menggunakan laman web dan perkhidmatan kami. Dengan mengakses laman web kami atau menggunakan mana-mana perkhidmatan kami, anda menerima amalan pemprosesan data yang diterangkan dalam dasar ini. Kami mematuhi peraturan perlindungan data yang terpakai."
                },
                {
                    "title": "2. Maklumat yang Kami Kumpulkan",
                    "description": "Kami mungkin mengumpulkan jenis maklumat berikut:",
                    "items": [
                        { "bold": "Maklumat akaun", "text": "Avatar pengguna, alamat e-mel, nama pengguna dan ID pengguna yang diberikan semasa log masuk melalui Google atau GitHub" },
                        { "bold": "Data penggunaan", "text": "Maklumat tentang bagaimana anda menggunakan perkhidmatan kami, termasuk ciri yang diakses dan masa penggunaan" },
                        { "bold": "Kandungan yang dimuat naik", "text": "Imej, video atau fail PDF yang anda muat naik untuk pemprosesan" },
                        { "bold": "Maklumat pembayaran", "text": "Maklumat pembayaran apabila membeli langganan (diproses dengan selamat oleh gerbang pembayaran pihak ketiga seperti Creem/Stripe/PayPal, kami hanya menyimpan rekod status pembayaran)" },
                        { "bold": "Data teknikal", "text": "Alamat IP, jenis pelayar, maklumat peranti" }
                    ]
                },
                {
                    "title": "3. Bagaimana Kami Menggunakan Maklumat Anda",
                    "description": "Kami menggunakan maklumat anda untuk:",
                    "items": [
                        { "text": "Menyediakan, mengekalkan dan meningkatkan perkhidmatan kami" },
                        { "text": "Memproses dan menyelesaikan transaksi" },
                        { "text": "Menghantar pemberitahuan teknikal dan mesej sokongan" },
                        { "text": "Menjawab komen dan soalan anda" },
                        { "text": "Menganalisis corak penggunaan untuk meningkatkan pengalaman pengguna, dan memproses data peribadi hanya setakat yang diperlukan untuk mencapai tujuan perkhidmatan" },
                        { "text": "Memastikan tempoh penyimpanan data peribadi tidak melebihi masa yang diperlukan" },
                        { "text": "Mencegah penipuan atau aktiviti haram" }
                    ]
                },
                {
                    "title": "4. Keselamatan Data",
                    "description": "Kami melaksanakan langkah keselamatan yang mematuhi standard industri untuk melindungi maklumat peribadi anda:",
                    "items": [
                        { "text": "Penyulitan AES-256 untuk fail semasa penghantaran dan penyimpanan" },
                        { "text": "Pemprosesan data sensitif menggunakan seni bina pengetahuan sifar" },
                        { "text": "Audit log keselamatan harian dan imbasan kerentanan" },
                        { "text": "Akses kakitangan mengikut prinsip keistimewaan minimum" }
                    ]
                },
                {
                    "title": "5. Perkongsian Data",
                    "description": "Kami tidak menjual maklumat peribadi anda. Kami mungkin berkongsi maklumat dengan:",
                    "items": [
                        { "bold": "Pembekal perkhidmatan", "text": "Terhad kepada pemprosesan data yang diperlukan untuk menyediakan perkhidmatan tertentu (seperti penyimpanan awan CloundFlare, gerbang pembayaran pihak ketiga seperti Creem/Stripe/PayPal), yang mesti menandatangani perjanjian pemprosesan data" },
                        { "bold": "Keperluan undang-undang", "text": "Apabila kami menerima saman, perintah mahkamah atau proses undang-undang lain yang sah yang terpakai kepada kami" }
                    ]
                },
                {
                    "title": "6. Hak Anda",
                    "description": "Mengikut undang-undang yang terpakai di rantau anda, anda mungkin mempunyai hak berikut:",
                    "items": [
                        { "text": "Mengakses salinan data peribadi anda" },
                        { "text": "Membetulkan maklumat yang tidak tepat atau tidak lengkap" },
                        { "text": "Hak untuk penghapusan data ('hak untuk dilupakan'), melainkan kami mempunyai sebab undang-undang untuk menyimpannya" },
                        { "text": "Menolak atau mengehadkan jenis pemprosesan data tertentu" },
                        { "text": "Hak kepada kemudahalihan data, anda boleh meminta pemindahan data anda" }
                    ]
                },
                {
                    "title": "7. Privasi Kanak-kanak",
                    "description": "Perkhidmatan kami tidak ditujukan kepada mereka yang berumur di bawah 16 tahun. Mengikut Artikel 8 Peraturan Perlindungan Data Umum (GDPR), persetujuan untuk kanak-kanak di bawah 16 tahun mesti diberikan oleh ibu bapa atau penjaga. Jika anda mengetahui bahawa seorang di bawah umur 16 tahun telah memberikan kami maklumat peribadi, sila hubungi kami dengan segera di support@clixmagic.com."
                },
                {
                    "title": "8. Perubahan pada Dasar Ini",
                    "description": "Kami mungkin mengemaskini Dasar Privasi ini dari semasa ke semasa. Kami akan memberitahu anda tentang sebarang perubahan penting dengan menerbitkan dasar baru di halaman ini dan mengemaskini tarikh 'kemas kini terakhir'. Untuk perubahan penting, kami akan memberitahu pengguna melalui e-mel atau dengan cara yang menonjol lain."
                },
                {
                    "title": "9. Hubungi Kami",
                    "description": "Jika anda mempunyai sebarang soalan tentang Dasar Privasi ini, sila hubungi kami di support@clixmagic.com. Jika anda percaya data anda telah diproses dengan cara yang tidak wajar atau mempunyai sebarang kerisauan, jangan ragu untuk menghubungi kami pada bila-bila masa."
                }
            ]
        },
        "cookies": {
            "sections": [
                {
                    "title": "1. Apa itu Kuki",
                    "description": "Kuki ialah fail teks kecil yang diletakkan di komputer atau peranti mudah alih anda apabila anda melawat laman web. Ia membolehkan laman web mengenali peranti anda dan mengingati jika anda telah melawat laman web sebelum ini."
                },
                {
                    "title": "2. Bagaimana Kami Menggunakan Kuki",
                    "description": "ClixMagicAI menggunakan kuki untuk pelbagai tujuan:",
                    "items": [
                        { "bold": "Kuki yang diperlukan", "text": "Diperlukan untuk fungsi asas laman web kami (seperti pengurusan sesi dan ciri keselamatan)" },
                        { "bold": "Kuki keutamaan", "text": "Mengingati tetapan dan keutamaan anda untuk meningkatkan pengalaman anda, contohnya, mengingati avatar, nama pengguna, dan lain-lain anda selepas log masuk melalui Google atau GitHub" },
                        { "bold": "Kuki analitik", "text": "Membantu kami memahami bagaimana pelawat berinteraksi dengan laman web kami dengan mengumpulkan maklumat tanpa nama" },
                        { "bold": "Kuki pemasaran", "text": "Menjejaki tabiat penyemakan imbas anda untuk menawarkan pengiklanan yang relevan dengan minat anda" }
                    ]
                },
                {
                    "title": "3. Jenis Kuki yang Kami Gunakan",
                    "subsection": [
                        {
                            "title": "3.1 Kuki yang Diperlukan",
                            "description": "Kuki ini penting untuk fungsi laman web yang betul. Mereka membolehkan fungsi teras seperti keselamatan, pengurusan rangkaian dan akses akaun (termasuk log masuk melalui Google dan GitHub). Anda boleh mengkonfigurasi pelayar anda untuk menyekat kuki ini, tetapi beberapa bahagian laman web mungkin tidak berfungsi dengan betul."
                        },
                        {
                            "title": "3.2 Kuki Prestasi dan Analitik",
                            "description": "Kuki ini membantu kami memahami bagaimana pelawat berinteraksi dengan laman web kami dengan mengumpulkan maklumat tanpa nama. Kami menggunakan data ini untuk meningkatkan laman web dan perkhidmatan kami. Kuki ini tidak mengumpulkan maklumat yang boleh mengenal pasti pelawat."
                        },
                        {
                            "title": "3.3 Kuki Fungsi",
                            "description": "Kuki ini membolehkan laman web kami mengingati pilihan yang anda buat (seperti keutamaan bahasa atau status log masuk) untuk menyediakan fungsi yang ditingkatkan, diperibadikan, seperti mengingati status log masuk anda melalui Google atau GitHub."
                        },
                        {
                            "title": "3.4 Kuki Penyasaran dan Pengiklanan",
                            "description": "Kuki ini digunakan untuk memaparkan pengiklanan yang relevan kepada pelawat dan menjejaki keberkesanan kempen pengiklanan kami. Sila ambil perhatian bahawa kerana laman web kami bergantung terutamanya pada log masuk pihak ketiga (Google dan GitHub), jenis kuki ini digunakan terutamanya untuk meningkatkan pengalaman pengguna dan bukan untuk pemasaran langsung."
                        }
                    ]
                },
                {
                    "title": "4. Pengurusan Kuki",
                    "description": "Anda boleh mengawal dan menguruskan kuki dengan pelbagai cara. Kebanyakan pelayar web membolehkan pengurusan keutamaan kuki. Anda boleh:",
                    "items": [
                        { "text": "Memadam kuki dari peranti anda" },
                        { "text": "Menyekat kuki dengan mengaktifkan tetapan pelayar anda yang membolehkan anda menolak sebahagian atau semua kuki" },
                        { "text": "Tetapkan pelayar anda untuk memberi amaran kepada anda apabila anda menerima kuki" }
                    ]
                },
                {
                    "title": "5. Kuki Pihak Ketiga",
                    "description": "Beberapa kuki diletakkan oleh pihak ketiga di laman web kami. Pihak ketiga ini mungkin termasuk perkhidmatan analitik (seperti Google Analytics) dan rangkaian pengiklanan. Disebabkan cara kuki berfungsi (kuki hanya boleh diakses oleh pihak yang pada asalnya menetapkannya), kami tidak mengawal penggunaan kuki pihak ketiga ini dan tidak boleh mengaksesnya. Untuk pengguna yang log masuk melalui Google dan GitHub, kami akan memastikan garis panduan privasi platform ini dipatuhi apabila berurusan dengan maklumat berkaitan."
                },
                {
                    "title": "6. Mengemaskini Dasar Kuki Ini",
                    "description": "Kami mungkin mengemaskini Dasar Kuki ini dari semasa ke semasa untuk mencerminkan perubahan dalam teknologi, peraturan atau amalan perniagaan kami. Sebarang perubahan akan diterbitkan di halaman ini dan tarikh semakan akan dikemaskini."
                },
                {
                    "title": "7. Hubungi Kami",
                    "description": "Jika anda mempunyai sebarang soalan tentang penggunaan kuki kami, sila hubungi kami di support@clixmagic.com."
                }
            ]
        }
    },
    FAQ: {
        title: "Panduan Penggunaan dan Soalan Lazim ClixMagicAI",
        prompt: "Menghadapi masalah atau mempunyai soalan? Hubungi kami pada bila-bila masa: support@clixmagic.com",
        questions: [
            {
                id : 1,
                question: "Apakah ClixMagicAI dan bagaimana ia berfungsi?",
                answer: "ClixMagicAI ialah alat penyingkiran tera air berteknologi AI yang canggih. Ia menyokong pengenalan automatik tera air dalam imej dan video, serta menyediakan fungsi penandaan manual kedudukan tera air. Untuk imej, ia menyokong pelbagai format penukaran dan menjamin output berkualiti tinggi; untuk video, ia boleh mengendalikan tera air statik, dinamik dan bahkan yang berubah bentuk."
            },
            {
                id : 2,
                question: "Adakah ClixMagicAI menawarkan penggunaan percuma?",
                answer: "Ya, kami menawarkan perkhidmatan asas percuma 3 mata setiap hari! Anda boleh menggunakannya untuk memproses imej (menggunakan 1 mata setiap operasi) atau video (menggunakan 3 mata setiap operasi). Selain itu, anda juga boleh membeli mata tambahan, dan semua mata yang dibeli sah secara kekal."
            },
            {
                id : 3,
                question: "Bolehkah saya membeli mata tambahan?",
                answer: "Sudah tentu! Selain daripada 3 mata percuma yang diberikan setiap hari, anda boleh mendapatkan mata tambahan melalui pilihan pembelian kami. Mata yang dibeli akan sah secara kekal, tanpa had tamat tempoh."
            },
            {
                id : 4,
                question: "Format fail apakah yang disokong?",
                answer: "Untuk imej, kami menyokong format PNG, JPEG, JPG, WEBP, HEIC dan HEIF, dengan HEIC dan HEIF akan ditukar secara automatik kepada PNG. Untuk video, kami menyokong pelbagai format termasuk MP4 dan MOV."
            },
            {
                id : 5,
                question: "Bagaimana privasi saya dilindungi?",
                answer: "Di ClixMagicAI, kami sangat menghargai privasi pengguna. Semua fail yang dimuat naik akan disulitkan dan dipadam secara automatik dalam masa 24 jam selepas pemprosesan selesai. Kami tidak menyimpan sebarang fail pengguna atau maklumat berkaitan."
            },
            {
                id : 6,
                question: "Bagaimana saya boleh log masuk ke ClixMagicAI?",
                answer: "Kami menyokong log masuk pantas melalui akaun GitHub atau Google, memastikan keselamatan akaun anda sambil memudahkan proses pendaftaran."
            },
            {
                id : 7,
                question: "Berapa pantas pemprosesan dilakukan?",
                answer: "Berkat pelayan berkuasa tinggi dan algoritma AI yang dioptimumkan, kebanyakan tugas penyingkiran tera air imej boleh selesai dalam masa 10 saat, manakala penyingkiran tera air video secepat 1 minit sahaja. Masa sebenar mungkin berbeza mengikut saiz dan kerumitan fail."
            },
            {
                id : 8,
                question: "Bagaimana kesan selepas pemprosesan?",
                answer: "Model AI kami telah dilatih secara meluas untuk menyingkirkan tera air daripada imej dan video secara pintar sambil mengekalkan kualiti kandungan asal. Sama ada tera air yang dikenal pasti secara automatik atau yang ditandakan secara manual, kedua-duanya boleh disingkirkan dengan berkesan, memastikan hasil akhir yang semula jadi tanpa meninggalkan kesan."
            },
            {
                id : 9,
                question: "Berapa lama tempoh sah setiap tugas?",
                answer: "Setelah tugas selesai, fail yang diproses akan disimpan di ClixMagicAI selama 24 jam untuk membolehkan pengguna memuat turun. Selepas tamat tempoh, fail akan dipadam secara automatik dari pelayan kami untuk melindungi privasi anda."
            },
            {
                id : 10,
                question: "Apakah had saiz fail maksimum?",
                answer: "Saiz fail imej maksimum yang kami terima adalah 10MB, manakala fail video maksimum adalah 100MB. Fail yang melebihi had ini mungkin perlu dimampatkan atau dipotong sebelum dimuat naik."
            }
        ]
    },
}